{
	"transactionCardHeader": "Een transactie valideren",
	"transactionCardDescriptionBold": "Wil je een transactie valideren voor een willekeurig project?",
	"transactionCardDescriptionRegular": "Als je een transactienummer bij de hand hebt, kun je het hier invoeren en de transactie valideren.",
	"showTransactionButton": "Transactie tonen",
	"transactionLabel": "Transactienummer",
	"errors": {
		"transactionIdRequired": "Transactienummer is verplicht.",
		"transactionNotFound": "Transactie niet gevonden.",
		"transactionIdInvalid": "Ongeldig transactienummer."
	}
}
